import React, { useState } from 'react';

import { IHeader2Fields } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';
import { useScrollPosition } from '../../hooks/useScrollPosition';

import { DesktopNavbar } from './Viewports/DesktopNav/DesktopNavComponents';
import { NavItem as MobileNav } from './Viewports/MobileNav';

import { NavbarContainer } from './styles';

export function Navbar(props: IHeader2Fields) {
  const [isScrolled, setIsScrolled] = useState(false);

  const { page: { hideHeader, isSimplified } = {} } = usePageDataContext();

  useScrollPosition(
    ({ currPos }) => {
      if (currPos.y > 0) setIsScrolled(true);
      else if (currPos.y <= 0) setIsScrolled(false);
    },
    [isScrolled],
    undefined,
    true,
    100
  );

  return (
    <header>
      <NavbarContainer>
        {!hideHeader && (
          <>
            <MobileNav
              {...props}
              isSimplified={!!isSimplified}
              isScrolled={isScrolled}
            />
            <DesktopNavbar
              {...props}
              isSimplified={!!isSimplified}
              isScrolled={isScrolled}
            />
          </>
        )}
      </NavbarContainer>
    </header>
  );
}
